/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell, faCog, faSignOutAlt, faUser, faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import userIcon from '../assets/images/user-icon.png';

function Navbar({ logout }) {
  const [showUserMenu, setShowUserMenu] = useState(false);

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  return (
    <nav className="bg-transparent px-10 py-4">
      <div className="flex items-center justify-between">
        {/* Left side - Breadcrumb or title */}
        <div className="flex items-center space-x-4">
          {/* Dynamic title can be added here based on current route */}
        </div>

        {/* Right side - Actions and User */}
        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <button
            type="button"
            className="relative p-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors duration-200"
          >
            <FontAwesomeIcon icon={faBell} className="text-lg" />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              3
            </span>
          </button>

          {/* Settings */}
          <Link
            to="/private"
            className="p-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors duration-200"
          >
            <FontAwesomeIcon icon={faCog} className="text-lg" />
          </Link>

          {/* User Profile */}
          <div className="relative">
            <button
              type="button"
              onClick={toggleUserMenu}
              className="flex items-center space-x-3 p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
            >
              <img
                className="h-8 w-8 bg-white rounded-full border-2 border-gray-300"
                src={userIcon}
                alt="User"
              />
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-white">Admin User</p>
                <p className="text-xs text-gray-300">Administrator</p>
              </div>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`text-sm text-gray-300 transition-transform duration-200 ${
                  showUserMenu ? 'rotate-180' : ''
                }`}
              />
            </button>

            {/* User Dropdown Menu */}
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-private-clr rounded-lg shadow-xl border border-clr-private py-2 z-50">
                <div className="px-4 py-2 border-b border-clr-private">
                  <p className="text-sm font-medium text-white">Admin User</p>
                  <p className="text-xs text-gray-300">admin@ans.com</p>
                </div>

                <Link
                  to="/private"
                  className="flex items-center px-4 py-2 text-sm text-gray-300 hover:bg-private hover:text-white transition-colors duration-200"
                >
                  <FontAwesomeIcon icon={faUser} className="mr-3 text-gray-400" />
                  Profile
                </Link>

                <Link
                  to="/private"
                  className="flex items-center px-4 py-2 text-sm text-gray-300 hover:bg-private hover:text-white transition-colors duration-200"
                >
                  <FontAwesomeIcon icon={faCog} className="mr-3 text-gray-400" />
                  Settings
                </Link>

                <div className="border-t border-clr-private mt-2 pt-2">
                  <button
                    type="button"
                    onClick={logout}
                    className="flex items-center w-full px-4 py-2 text-sm text-red-400 hover:bg-red-900/20 hover:text-red-300 transition-colors duration-200"
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="mr-3" />
                    Sign Out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default Navbar;
